// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span {
  font-weight: bold;
}

.d-flex {
  gap: 0.5rem;
}
.d-flex input {
  width: auto;
  min-width: 25rem;
}
@media (min-width: 768px) {
  .d-flex input {
    min-width: 19rem;
  }
}

@media (max-width: 767.98px) {
  .d-flex {
    gap: 0;
    flex-direction: column;
  }
  .d-flex input {
    margin-bottom: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/header/prestador/header-prestador.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;AACD;;AACA;EACC,WAAA;AAED;AADC;EACC,WAAA;EACA,gBAAA;AAGF;AAFQ;EAHP;IAIE,gBAAA;EAKD;AACF;;AADA;EACC;IACC,MAAA;IACM,sBAAA;EAIN;EAHA;IACU,qBAAA;EAKV;AACF","sourcesContent":["span {\n\tfont-weight: bold;\n}\n.d-flex {\n\tgap: 0.5rem;\n\t& input {\n\t\twidth: auto;\n\t\tmin-width: 25rem;\n        @media (min-width: 768px) {\n\t\t\tmin-width: 19rem;\n        }\n\t}\n}\n\n@media (max-width: 767.98px) {\n\t.d-flex {\n\t\tgap: 0;\n        flex-direction: column;\n\t\t& input {\n            margin-bottom: 0.5rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
